<template>
  <main class="login-layout">
    <div id="inicio">
      <div id="brasao-ufc">
        <img
          src="@/assets/brasaoUFC.png"
          alt="logo do brasão da UFC "
        />
        <h4>
          <a
            id="link"
            href="https://prex.ufc.br/pt/"
            target="_blank"
            >PRÓ-REITORIA DE EXTENSÃO</a
          >
        </h4>
      </div>

      <div
        id="tela-login"
        v-if="router.currentRoute.value.path === '/login'"
      >
        <div id="logo-gex">
          <router-link to="/">
            <img
              src="@/assets/logoGex_colorida.png"
              alt="logo do Gex"
            />
          </router-link>
        </div>

        <div id="ajuda">
          <p>
            Vínculo com a UFC? Acesse pelo Sigaa. Caso contrário, use o GEX.
          </p>
        </div>

        <div
          id="form-escolha"
          v-show="primeiroLogin == null"
        >
          <router-link
            type="button"
            class="btn btn-primary fazer-login"
            to="/login/autenticacao-sigaa"
          >
            Entrar pelo SIGAA
          </router-link>

          <router-link
            type="button"
            class="btn btn-primary fazer-login"
            to="/login/autenticacao-gex"
          >
            Entrar pelo GEX
          </router-link>
        </div>
      </div>
      <div
        id="tela-login"
        v-else
      >
        <router-view />
      </div>
    </div>
  </main>
</template>

<script setup>
import router from "@/router";
import { onMounted, onUpdated, ref } from "vue";
import { onBeforeRouteUpdate } from "vue-router";
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: "Calibri", sans-serif;
}

.login-layout {
  background: linear-gradient(90deg, #362065 0%, #5e2ea0 100%);
  min-height: 100vh;
  display: grid;
  place-items: center;
  padding: 1rem;
}

#inicio {
  display: grid;
  grid-template-columns: 1fr 1fr;
  max-width: 900px;
  width: 100%;
  background: #ffffff;
  border-radius: 20px;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  min-height: 600px;
}

#brasao-ufc {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  border-right: 1px solid #e2e8f0;
}

#brasao-ufc img {
  width: 70%;
  margin-bottom: 1rem;
}

#link {
  text-decoration: none;
  font-weight: 600;
  font-size: 1rem;
  color: #1e293b;
  transition: 0.3s ease;
}

#link:hover {
  color: #060a11;
}

#tela-login {
  padding: 3rem 2.5rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

#logo-gex {
  text-align: center;
  margin-bottom: 1.5rem;
}

#logo-gex img {
  width: 50%;
  border-radius: 12px;
}

#ajuda {
  text-align: center;
  margin-bottom: 2rem;
}

#ajuda p {
  color: #64748b;
  font-size: 0.9rem;
}

#form-escolha {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
}

.fazer-login {
  width: 100%;
  padding: 1rem;
  background: #2154c2;
  color: #ffffff;
  border: none;
  border-radius: 12px;
  font-size: 1rem;
  font-weight: 600;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s ease;
}

.fazer-login:hover {
  background: #6f319a;
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(37, 99, 235, 0.3);
}

/* Responsividade */
@media (max-width: 900px) {
  #inicio {
    grid-template-columns: 1fr; /* uma coluna só no mobile */
    min-height: auto;
  }

  #brasao-ufc {
    border-right: none;
    border-bottom: 1px solid #e2e8f0;
    padding: 1.5rem;
  }

  #tela-login {
    padding: 2rem 1.5rem;
  }

  #logo-gex img {
    width: 70%;
  }
}

@media (max-width: 500px) {
  .fazer-login {
    font-size: 0.9rem;
    padding: 0.8rem;
  }

  #ajuda p {
    font-size: 0.8rem;
  }

  #link {
    font-size: 0.9rem;
  }
}
</style>
